import SessionService from "../../services/session/SessionService";

interface PermissionWrapperProps {
    permissionCodePath: string;
    children: React.ReactNode;
}

const PermissionWrapper: React.FC<PermissionWrapperProps> = (props)=> {
    let admin = SessionService.getInstance().getCurrentUserProfile().admin;
    let userPermissions = SessionService.getInstance().getCurrentUserPermissions();
    let hideOnDataSummaryTenant = SessionService.getInstance().getCurrentUserProfile().tenantNo == 'ADMIN';
    if (!hideOnDataSummaryTenant && (admin || userPermissions.includes(props.permissionCodePath))) {
        return props.children;
    } else {
        return null;
    }
};

export default PermissionWrapper;